/* KUTEÈ header — desktop nav dropdowns, single owner of this behavior.
   Dawn's <details> menus open on click only; this adds:
   - hover-open with a 150ms close delay so the cursor can travel into
     the panel (pointer devices ≥990px),
   - open on keyboard focus so the submenu stays tabbable,
   - click-through on parents that carry data-url (their menu link,
     e.g. SHOP → /collections/all) instead of only toggling.
   Loaded on every page from header.liquid. Mobile drawer untouched. */
(() => {
  const hoverMedia = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const desktop = window.matchMedia('(min-width: 990px)');

  const init = () => {
    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.__kuNavInit) return;
      details.__kuNavInit = true;

      const summary = details.querySelector(':scope > summary');
      let closeTimer = null;

      details.addEventListener('mouseenter', () => {
        if (!hoverMedia.matches) return;
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        if (!hoverMedia.matches) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      details.addEventListener('focusin', () => {
        if (desktop.matches) details.setAttribute('open', '');
      });

      if (summary && summary.dataset.url) {
        summary.addEventListener('click', (event) => {
          const url = summary.dataset.url;
          if (!desktop.matches || !url || url === '#') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = url;
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
